import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class CntParcialAttribute extends Sensor {
  public cntParcialChart: any;
  private cntParcialSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.cntParcialChart = null;
    this.cntParcialSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.cntParcialSensor, position);
      this.cntParcialSensor[position].push([timestamp, element.cntParcial]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredCntParcial = this.cntParcialSensor.filter(series => series.length > 0);

    const positionNodeCntParcial = this.cntParcialSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.cntParcialChart = this.getConfigChar(
      'cntParcial',
      this.getChartSeriesNewNode('Sensor', filteredCntParcial, positionNodeCntParcial),
      this.getRanges('cntParcial'),
      this.getLimits('cntParcial'),
      'column'

    );
  }

  public hasCntParcialSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.cntParcialSensor.length &&
      this.cntParcialSensor[index].length > 0
    );
  }

  public getCntParcialSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.cntParcialSensor.length) {
      const sensorData = this.cntParcialSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Contador de pulso', value: 'cntParcial' }
    ];
  }
}
